<template>
  <div>
    <el-form-item label="驳回原因">
      <el-input v-model="reason"></el-input>
    </el-form-item>
    <div class="buttons">
      <el-button @click="$router.back()">取消</el-button>
      <el-button type="danger"
                 @click="voidFail()">驳回
      </el-button>
      <el-button type="danger"
                 v-if="form.is_current_month === 1"
                 @click="voidReceipt()">通过作废申请
      </el-button>
      <el-button type="danger"
                 v-if="form.is_current_month === 0"
                 @click="openRedFlush">通过红冲申请
      </el-button>
    </div>

    <el-dialog :visible.sync="redFlushVisible"
               title="填写红字发票信息"
               width="40%">
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px">
        <div class="re-el-form__flex">
          <div class="medium"
               style="width: 500px">
            <el-form-item label="红字发票号码"
                          required>
              <el-input v-model="invoice_number"
                        placeholder="开具红字发票时需填写">
              </el-input>
            </el-form-item>

            <el-form-item label="红字发票代码"
                          v-if="[1,2,3].includes(form.type)"
                          required>
              <el-input v-model="invoice_code"
                        placeholder="开具红字发票时需填写">
              </el-input>
            </el-form-item>

            <el-form-item label="红字发票开票日期"
                          required>
              <el-date-picker v-model="invoice_time"
                              style="width: 100%;"
                              value-format="yyyy-MM-dd"
                              :picker-options="dateTimePickerRangeOptions"
                              type="date"
                              align="center"
                              placeholder="选择日期">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="红字发票文件"
                          v-if="[4,5].includes(form.type)"
                          required
                          prop="e_invoice_url">
              <el-upload class="upload-e-invoice"
                         action=""
                         :auto-upload="false"
                         :on-change="(file, fileList) => {onChangeFile(file, fileList, this.e_invoice_url)}"
                         :before-remove="(file, fileList) => {beforeRemove(file, fileList, this.e_invoice_url)}"
                         multiple
                         :limit="20"
                         :on-exceed="(file, fileList) => {handleExceed(file, fileList, 20)}"
                         :file-list="e_invoice_url"
                         ref="upload"
                         accept=".pdf">
                <el-tooltip class="item"
                            effect="dark"
                            content="请上传PDF文件"
                            placement="right">
                  <el-button size="small"
                             type="primary">点击上传
                  </el-button>
                </el-tooltip>
              </el-upload>
            </el-form-item>

          </div>
        </div>
      </el-form>
      <div style="margin-left: 350px">
        <el-button @click="cancelRedFlush()">取消</el-button>
        <el-button type="primary"
                   @click="redFlushReceipt()">保存
        </el-button>
      </div>
    </el-dialog>

    <InvoiceSplitRedVoid v-if="showSplitDetail"
                         :dataSource="form.split_list"
                         @onClose="showSplitDetail = false"
                         @onSave="handleRedTicketSplit"/>
  </div>
</template>

<script>
import InvoiceSplitRedVoid from './ticket-split/InvoiceSplitRedVoid'

export default {
  components: {
    InvoiceSplitRedVoid
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    }
  },
  data () {
    return {
      reason: '',
      invoice_time: '',
      invoice_number: '',
      invoice_code: '',
      e_invoice_url: [],
      redFlushVisible: false,
      showSplitDetail: false,
      dateTimePickerRangeOptions: {
        disabledDate: function (time) {
          return time.getTime() > Date.now()
        },
      },
    }
  },
  methods: {
    // 作废驳回
    voidFail () {
      if (this.reason) {
        this.$confirm('即将驳回本次退票申请，是否确认？', '驳回退票申请确认', {type: 'warning', center: true}).then(() => {
          request.common('rejectReturnInvoiceApply', {id: this.$route.params.id, reason: this.reason}).then((res) => {
            this.$router.push('/invoice-apply/approve/table')
          })
        })
      } else {
        this.$alert('必须填写驳回原因', '提示', {
          type: 'error',
        })
      }
    },
    // 作废发票
    voidReceipt () {
      if (this.form.is_split) {
        request.common('returnSplitTicket', {receipt_apply_id: this.$route.params.id}).then((res) => {
          this.$router.push('/invoice-apply/split/table?receipt_apply_id=' + this.$route.params.id)
        })
      } else {
        this.$confirm('即将作废本开票申请，是否确认？', '作废开票申请确认', {
          type: 'warning',
          center: true
        }).then(() => {
          request.common('passReturnInvoiceApply', {id: this.$route.params.id}).then((res) => {
            this.$router.push('/invoice-apply/approve/table')
          })
        })
      }
    },
    openRedFlush () {
      if (this.form.is_split) {
        this.showSplitDetail = true
      } else {
        this.redFlushVisible = true
      }
    },
    handleRedTicketSplit (data) {
      const params = {
        receipt_apply_id: this.$route.params.id,
        split_list: data.map(item => {
          item.ticket_json.forEach(ticketItem => {
            delete ticketItem.invoice_name_json
          })
          return {
            id: item.id,
            order_no: item.order_no,
            notice_number: item.notice_number,
            ticket_json: item.ticket_json,
          }
        })
      }
      request.common('createRedFlushReceiptSplitData', params).then(res => {
        this.$message.success('红冲发票开具成功')
        this.$router.push('/invoice-apply/approve/table')
      })
    },
    redFlushReceipt () {
      if (this.checkForm()) {
        this.$confirm('即将作废本开票申请并开具红冲发票，是否确认？', '作废开票申请确认', {
          type: 'warning',
          center: true
        }).then(() => {
          request.common('createRedFlushTicket', {
            id: this.$route.params.id,
            invoice_number: this.invoice_number,
            invoice_code: this.invoice_code,
            invoice_time: this.invoice_time,
            e_invoice_url: this.e_invoice_url,
          }).then((res) => {
            this.$message.success('红冲发票开具成功')
            this.$router.push('/invoice-apply/approve/table')
          })
        })
      }
    },
    cancelRedFlush () {
      Object.assign(this.$data, this.$options.data())
      this.redFlushVisible = false
    },
    checkForm () {
      const field = {
        invoice_number: '发票号码',
        invoice_code: '发票代码',
        invoice_time: '开票日期',
      }
      if ([4, 5].includes(this.form.type)) {
        if (this.e_invoice_url.length < 1) {
          this.$message.error('红字发票文件不得为空')
          return false
        }
        delete field.invoice_code
      }
      for (let key in field) {
        if (!this[key]) {
          this.$message.error(field[key] + '不得为空')
          return false
        }
      }
      return true
    },
    onChangeFile (file, fileList, formField) {
      let isLt20M = file.raw.size / 1024 / 1024 < 20
      if (!isLt20M) {
        this.$message.error('大小不能超过20MB!')
        this.$refs.upload.clearFiles()
        return false
      }
      this.onUploadFile(file.raw, fileList, formField)
    },
    onUploadFile (file, fileList, formField) {
      this.fileUpLoading = true
      let formData = new FormData()
      formData.append('file', file)
      return request.alert('uploadInvoiceApplyFile', formData).then(({data}) => {
        this.$message({ showClose: true, message: '上传成功', type: 'success' })
        let index = this.getFileListIndex(file, fileList)

        let type = 'other'
        if ((file.name.substr(-5).toLowerCase() === '.jpeg') || (file.name.substr(-4).toLowerCase() === '.jpg') || (file.name.substr(-4).toLowerCase() === '.png')) {
          type = 'pic'
        } else if (file.name.substr(-4).toLowerCase() === '.pdf') {
          type = 'pdf'
        } else if (file.name.substr(-4).toLowerCase() === '.eml') {
          type = 'eml'
        } else if (file.name.substr(-5).toLowerCase() === '.docx' || (file.name.substr(-5).toLowerCase() === '.xlsx') || (file.name.substr(-4).toLowerCase() === '.doc')) {
          type = 'office'
        }
        if (index > -1) {
          fileList[index].status = 'success'
          formField[index] = {name: file.name, url: data, type: type}
        }
        this.fileUpLoading = false
      }).catch(_ => {
        this.$refs.upload.uploadFiles.pop()
        this.fileUpLoading = false
      })
    },
    getFileListIndex (file, fileList) {
      for (let i = 0; i < fileList.length; i++) {
        let fileTemp
        if (fileList[i].raw) {
          fileTemp = fileList[i].raw
        } else {
          fileTemp = fileList[i]
        }
        if (file === fileTemp) {
          return i
        }
      }
      return -1
    },
    handleExceed (files, fileList, max) {
      this.$message.warning(`当前限制选择 ${max} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeRemove (file, fileList, formField) {
      let fileTemp
      if (file.raw) {
        fileTemp = file.raw
      } else {
        fileTemp = file
      }
      let index = this.getFileListIndex(fileTemp, fileList)
      if (index > -1) {
        formField.splice(index, 1)
      }
    },
  },
}
</script>

<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.buttons {
  float: right;
  padding: 0 30px 30px 0;
}

// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/components/InvoiceVoidDialog.vue